export const isPolicyInactiveByPolicyStatus = (policyStatus) => {
  const terminatedPoliciesStatues = [
    "inactive",
    "terminated",
    "cancelled",
    "expired",
    "lapsed",
    "surrendered",
    "deceased",
    "matured",
    "administrative rewrite",
    "term conversion",
  ];
  return terminatedPoliciesStatues.includes(policyStatus?.toLowerCase());
};
